import * as Sentry from '@sentry/react';
import React from 'react';

import AppMain from './app-main';
import { AppProviders } from './app-providers';
import { ErrorModal } from './components/modals/variants/error-modal';
import { AppInitialization } from './state/app-initialization';

export function AppMainEntry () {
    return (
        <AppProviders baseName={'/'}>
            <AppInitialization>
                <Sentry.ErrorBoundary fallback={() => <ErrorModal />}>
                    <AppMain />
                </Sentry.ErrorBoundary>
            </AppInitialization>
        </AppProviders>
    );
}
